// TODO: Color helpers consumed by layout/ApplyBranding (branding :root injection).
// Extend with additional color utilities as later phases need them (Rule 7).
import identity from 'lodash/identity';
import trim from 'lodash/trim';

// Builds a CSS custom-property line, e.g. printCss('h', toHue)('primary', '#fff')
// → "--primary-h: 210;". `suffix` selects the channel ('' = full hsl()).
export const printCss =
    (suffix = '', convert = identity) =>
    (property, value) =>
        `--${property}${suffix ? '-' + suffix : ''}: ${convert(value)};`;

// Internal: convert decimal r/g/b (0–255, possibly whitespace-padded strings) to [h, s, l].
const rgbToHsl = (red, green, blue) => {
    const r = Number(trim(red)) / 255;
    const g = Number(trim(green)) / 255;
    const b = Number(trim(blue)) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h = 0;
    let s = 0;

    if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            default:
                // max === b
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }

    return [Math.round(360 * h), Math.round(100 * s), Math.round(100 * l)];
};

// from @josh3736 | https://stackoverflow.com/a/3732187
export const colorToHsl = (color) => {
    if (color.slice(0, 1) === '#') {
        if (color.length === 4) {
            const r = Number.parseInt(color.slice(1, 2) + color.slice(1, 2), 16);
            const g = Number.parseInt(color.slice(2, 3) + color.slice(2, 3), 16);
            const b = Number.parseInt(color.slice(3, 4) + color.slice(3, 4), 16);
            return rgbToHsl(r, g, b);
        }
        const r = Number.parseInt(color.slice(1, 3), 16);
        const g = Number.parseInt(color.slice(3, 5), 16);
        const b = Number.parseInt(color.slice(5, 7), 16);
        return rgbToHsl(r, g, b);
    }
    if (color.slice(0, 4) === 'rgba') {
        const [r, g, b] = color.slice(5, -1).split(',');
        return rgbToHsl(r, g, b).slice(0, 3);
    }
    if (color.slice(0, 3) === 'rgb') {
        const [r, g, b] = color.slice(4, -1).split(',');
        return rgbToHsl(r, g, b);
    }
    if (color.slice(0, 4) === 'hsla') {
        return color.slice(5, -1).split(',').slice(0, 3);
    }
    if (color.slice(0, 3) === 'hsl') {
        return color.slice(4, -1).split(',');
    }
    // Named color values are not yet supported — default to dark gray.
    return [0, 0, 16];
};
